






import { computed, defineComponent, ref } from "@vue/composition-api";
import { StreamingHelper } from "@scrile/streaming-client";
import { isMobile } from "@/lib/browserUtils";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "MobileSwitchCam",
  components: { BaseButton, BaseIcon },
  props: {
    videoTracks: { type: Array as () => MediaStreamTrack[], required: true },
    showCaption: { type: Boolean, default: false },
    iconSize: { type: Number, default: 28 },
    iconColor: { type: String, default: "var(--palette-unchanged-bg)" },
  },
  setup(props, { emit }) {
    const deviceId = computed(() => {
      if (props.videoTracks.length === 0) {
        return false;
      }
      return props.videoTracks[0].getSettings().deviceId ?? true;
    });
    const deviceList = ref<MediaDeviceInfo[]>([]);
    const facingMode = ref<"user" | "environment">("user");
    if (!isMobile()) {
      new StreamingHelper().getDeviceList().then(({ videoInputList }) => (deviceList.value = videoInputList));
    }

    const mobileSwitchCam = (): MediaTrackConstraints => {
      facingMode.value = facingMode.value === "user" ? "environment" : "user";
      return {
        facingMode: facingMode.value,
      };
    };

    const desktopSwitchCam = (): MediaTrackConstraints => {
      const index = deviceList.value.findIndex(i => i.deviceId === deviceId.value);
      const nextIndex = index === -1 ? 1 : index + 1;
      const deviceInfo = deviceList.value[nextIndex < deviceList.value.length ? nextIndex : 0];
      return {
        deviceId: { exact: deviceInfo.deviceId },
      };
    };

    const show = computed(() => isMobile() || deviceList.value.length >= 2);

    const onClick = () => {
      let constraints: MediaTrackConstraints;
      if (isMobile()) {
        constraints = mobileSwitchCam();
      } else {
        constraints = desktopSwitchCam();
      }
      emit("changeDevice", { video: constraints });
    };
    return {
      show,
      onClick,
    };
  },
});
